"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const Fonts_1 = require("./Fonts");
const URL = 'https://static.vente-privee.com/vp5/fonts/';
const fontFaceLite = (family, path, weight, style) => (0, styled_components_1.css) `
  @font-face {
    font-family: ${family};
    src:
      url(${URL}${path}.woff2) format('woff2'),
      url(${URL}${path}.woff) format('woff'),
      url(${URL}${path}.otf) format('opentype');
    font-weight: ${weight};
    font-style: ${style};
  }
`;
const FontsLite = (0, Fonts_1.getFontFaces)(fontFaceLite);
exports.default = FontsLite;
